import { BrowserAssistInbox } from '../browserAssist/Inbox';
import { ReminderInbox } from './ReminderInbox';
import { NavLink, Outlet } from 'react-router-dom';
import type { AuthSession as User } from '../auth';
import { isDelegated, signIn, signOut } from '../auth';
import { version as extensionVersion } from '../../../../browser-extension/manifest.json';

export type WorkspaceContext = { user: User | null };
const navigation = [
  ['/household-planning', 'Haushalt und Lebensplanung'], ['/properties', 'Objekte'], ['/properties/search', 'Immobiliensuche'], ['/properties/ranking', 'Präferenzrangliste'], ['/purchase-workflow', 'Kaufbegleitung · Demo'], ['/calculator', 'Rechner'], ['/research/cohorts', 'Modellvergleich'], ['/crawls', 'Crawls'], ['/profile', 'Profil']
] as const;
export function WorkspaceShell({ user }: WorkspaceContext) {
  return <div className="workspace-shell">
    <header className="topbar"><NavLink className="brand" to="/properties">Immobilien · Workspace</NavLink>
      <nav aria-label="Hauptnavigation">{navigation.map(([to, label]) => <NavLink key={to} to={to}>{to==='/purchase-workflow'&&user?'Kaufbegleitung':label}</NavLink>)}<a href={`/downloads/real-estate-research-extension.zip?version=${extensionVersion}`} download="real-estate-research-extension.zip">Browser-Erweiterung herunterladen</a></nav>
      {user ? <button className="quiet-button" type="button" onClick={() => void signOut()}>{isDelegated(user) ? 'Delegierten Zugang schließen' : 'Abmelden'}</button> : sessionStorage.getItem('rec-auth-mode') === 'delegated' ? <span>Neuer Calculator-Handoff erforderlich</span> : <button type="button" onClick={() => void signIn()}>Anmelden</button>}
    </header>
    <ReminderInbox user={user} />
    <BrowserAssistInbox user={user}/>
    <main className="workspace-main"><Outlet context={{ user } satisfies WorkspaceContext} /></main>
  </div>;
}
